import React, { Component } from "react";

class BuildModelHead extends Component {
  render() {
    return (
      <React.Fragment>
        <div className="icon-wrapper print_disnone">
          <div className="search-btn">
            <button
              className={
                "greenbtn " + (this.props.page === "details" ? "active" : "")
              }
              onClick={() => {
                this.props.setPage("details");
              }}
            >
              <p className="pstyle">
                <i className="fa fa-search brand_icon" aria-hidden="true" />
              </p>
              Cross-Reference
            </button>

            <button
              className={
                "bluebtn " + (this.props.page === "knowmore" ? "active" : "")
              }
              onClick={() => {
                this.props.setPage("knowmore");
              }}
            >
              <p className="pstyle">
                <i className="fa fa-hand-o-up brand_icon" aria-hidden="true" />
              </p>
              Build a Heatcraft Model
            </button>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default BuildModelHead;
